// ============================================================================
// FILE: src/modules/ticket/components/performance/PerformanceFilterBar.jsx
// PURPOSE:
//   Filter UI for Ticket Performance Dashboard
//   - Date range
//   - Period
//   - SLA / Status / Assignment
// ============================================================================

import React from "react";

export default function PerformanceFilterBar({
  filters,
  onChange,
  onReset,
}) {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 12,
        padding: 12,
        border: "1px solid #ddd",
        borderRadius: 8,
        marginBottom: 16,
        background: "#fafafa",
      }}
    >
      {/* ------------------------------------------------------------ */}
      {/* Period */}
      {/* ------------------------------------------------------------ */}
      <select
        value={filters.period || ""}
        onChange={(e) =>
          onChange({
            period: e.target.value || null,
            from_date: null,
            to_date: null,
          })
        }
      >
        <option value="">Custom Period</option>
        <option value="last_7_days">Last 7 Days</option>
        <option value="last_30_days">Last 30 Days</option>
        <option value="mtd">Month To Date</option>
        <option value="ytd">Year To Date</option>
      </select>

      {/* ------------------------------------------------------------ */}
      {/* From Date */}
      {/* ------------------------------------------------------------ */}
      <input
        type="date"
        value={filters.from_date || ""}
        onChange={(e) =>
          onChange({
            from_date: e.target.value,
            period: null,
          })
        }
      />

      {/* ------------------------------------------------------------ */}
      {/* To Date */}
      {/* ------------------------------------------------------------ */}
      <input
        type="date"
        value={filters.to_date || ""}
        onChange={(e) =>
          onChange({
            to_date: e.target.value,
            period: null,
          })
        }
      />

      {/* ------------------------------------------------------------ */}
      {/* Status */}
      {/* ------------------------------------------------------------ */}
      <select
        value={filters.status || ""}
        onChange={(e) =>
          onChange({ status: e.target.value || null })
        }
      >
        <option value="">All Status</option>
        <option value="OPEN">Open</option>
        <option value="IN_PROGRESS">In Progress</option>
        <option value="RESOLVED">Resolved</option>
        <option value="CLOSED">Closed</option>
        <option value="REOPENED">Reopened</option>
      </select>

      {/* ------------------------------------------------------------ */}
      {/* SLA Status */}
      {/* ------------------------------------------------------------ */}
      <select
        value={filters.sla_status || ""}
        onChange={(e) =>
          onChange({ sla_status: e.target.value || null })
        }
      >
        <option value="">All SLA</option>
        <option value="MET">SLA Met</option>
        <option value="BREACHED">SLA Breached</option>
      </select>

      {/* ------------------------------------------------------------ */}
      {/* Assignment */}
      {/* ------------------------------------------------------------ */}
      <select
        value={
          filters.assigned === null
            ? ""
            : filters.assigned
            ? "assigned"
            : "unassigned"
        }
        onChange={(e) => {
          const v = e.target.value;
          onChange({
            assigned:
              v === ""
                ? null
                : v === "assigned"
                ? true
                : false,
          });
        }}
      >
        <option value="">All Tickets</option>
        <option value="assigned">Assigned</option>
        <option value="unassigned">Unassigned</option>
      </select>

      {/* ------------------------------------------------------------ */}
      {/* Reset */}
      {/* ------------------------------------------------------------ */}
      <button
        onClick={onReset}
        style={{
          marginLeft: "auto",
          padding: "4px 12px",
        }}
      >
        Reset
      </button>
    </div>
  );
}
